import axios from 'axios';

/**
 * Local dev: use same-origin `/api/v1` + package.json `proxy` → backend :5002
 * (avoids CORS and localhost vs 127.0.0.1 mismatches). Remote dev URLs still
 * go direct when REACT_APP_API_URL points off-machine.
 */
function resolveApiBaseURL(): string {
  const raw = process.env.REACT_APP_API_URL?.replace(/\r?\n/g, '').trim() ?? '';
  if (process.env.NODE_ENV === 'development') {
    const localBackend =
      !raw ||
      /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/i.test(raw);
    if (localBackend) return '/api/v1';
    return raw;
  }
  return raw || 'http://localhost:5002/api/v1';
}

const baseURL = resolveApiBaseURL();

export const api = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('odc_access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('odc_access_token');
      localStorage.removeItem('odc_refresh_token');
      const p = window.location.pathname;
      const publicPaths = ['/', '/login', '/pricing', '/faq'];
      if (!publicPaths.includes(p)) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
